import * as React from "react";
import {
    DataGrid,
    GridColDef,
    GridRowSelectionModel,
} from "@mui/x-data-grid";
import { FC } from "react";
import { useTranslations } from "../../hooks/useTranslations";
var _ = require('lodash');

export type GroupThresholdProps = {
    usergroupData: any;
    handleGroupsSelection: (value: any) => void;
    setRowSelectionModel: React.Dispatch<React.SetStateAction<GridRowSelectionModel>>;
    rowSelectionModel: GridRowSelectionModel;
};

export const GroupsThreshold: FC<GroupThresholdProps> = ({
    usergroupData,
    handleGroupsSelection,
    setRowSelectionModel,
    rowSelectionModel
}) => {

    const labels = useTranslations()

    const columns: GridColDef[] = [
        {
            field: "groupName",
            headerName: labels.GroupName,
            width: 200,
            editable: false,
        },
        {
            field: "groupDescription",
            headerName: labels.GroupDescription,
            width: 400,
            editable: false,
        },
    ];

    return (
        <div style={{ height: 400, width: "100%" }}>
            <DataGrid
                sx={{
                    display: "flex",
                    flexDirection: "column-reverse",
                    width: "95%",
                }}
                rows={usergroupData}
                autoHeight={true}
                columns={columns}
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 5,
                        },
                    },
                }}
                localeText={{
                    noRowsLabel: "Nothing to display"
                }}
                pageSizeOptions={[5]}
                checkboxSelection
                //onRowClick={handleRoute}
                onRowSelectionModelChange={(newRowSelectionModel) => {
                    setRowSelectionModel(newRowSelectionModel)
                    handleGroupsSelection(newRowSelectionModel)
                }}
                rowSelectionModel={rowSelectionModel}
                disableRowSelectionOnClick
            />
        </div>
    );
};
